<template>
  <div
    ref="productElement"
    class="product"
  >
    <p class="description">
      {{ product.description }}
    </p>
    <p class="details">
      {{ product.details }}
    </p>
    <div
      :id="'container-product-price-' + globalId"
      ref="containerProductPrice"
      class="container-product-price"
    />
    <div
      :id="'container-product-link-' + globalId"
      ref="containerProductLink"
      :class="['container-product-link']"
    />
  </div>
</template>
<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    globalId() {
      return `${this.$store.state.config.id}-${this.product.id}`;
    },
  },
  mounted() {
    this.addElements();
  },
  destroyed() {
    this.removeElements();
  },
  methods: {
    addElements() {
      // inject html structure from MDP website
      this.refElement = this.$refs.productElement;
      if (window.products && window.products[this.globalId].priceElement && window.products[this.globalId].linkElement) {
        document.getElementById(`container-product-price-${this.globalId}`).appendChild(window.products[this.globalId].priceElement);
        document.getElementById(`container-product-link-${this.globalId}`).appendChild(window.products[this.globalId].linkElement);
      } else {
        requestAnimationFrame(() => {
          this.addElements();
        });
      }
    },
    removeElements() {
      // wait until elements is in the dom during transition
      if (this.refElement && this.elementIsAttachedToDocument(this.refElement)) {
        requestAnimationFrame(() => {
          this.removeElements();
        });
      } else if (window.products && window.products[this.globalId].priceElement && window.products[this.globalId].linkElement) {
        window.products[this.globalId].priceElement.parentNode.appendChild(window.products[this.globalId].priceElement);
        window.products[this.globalId].linkElement.parentNode.appendChild(window.products[this.globalId].linkElement);
      }
    },
    elementIsAttachedToDocument(element) {
      while (element !== document && element.parentNode) {
        element = element.parentNode; // eslint-disable-line
      }
      return element === document;
    },
  },
};
</script>

<style lang="stylus" scoped>
.product {
  text-align: center;

  >>> .product-price {
    display: inline-block;
  }

  >>> .action {
    &.btn,
    &.primary,
    &.alert {
      @extends $cta;
      margin-top: 10px;
    }
  }
  >>> .field {
    @extends $field;
    margin-top: 10px;
  }

  >>> .message {
    @extends $txt-default;
    margin: 10px 0 0 0;
  }
}

.description {
  @extends $txt-medals-name;
  white-space: break-spaces;
}

.details {
  @extends $txt-medals-detail;
  white-space: break-spaces;
}

.container-product-price {
  @extends $txt-medals-price;
}
</style>
